import { ErsMessage } from "interface/common"
import { LandingNoteHead } from "interface/landingNote"

export interface Comment {
    id : number
    noteHeadId? : number
    lineNumber : number
    description : string
    noteLineId?: number
}

export const requirementFields ={
    //diaryNumber: false,
    tripNumber: false,
    firstCatchDate: false,
    lastCatchDate: false,
    catchYear: false,
    crewSize: false,
    norwegianCrewSize: false,
    vesselOfficersNorwegian: false,
    // departureDate: false,
    // arrivalDate: false,
    quotaTypeCode: false,
    quotaNationCode: false,
    landingNationCode: false,
    partialLandingId: false,
    vesselCaptainsName: false,
    // productionFacilityId: false,
    vesselApprovalNumber: true,
    recordNumberErs: false,
    fishingGearId: false,
    catchField: false,
}

const  isPass = ( field : string | number | null | undefined, allowZero: boolean = false) => {
    return field !== null && field !== "" && field !== undefined && (allowZero || field !== 0);
}
  export const handleRequirementCheck = (form: LandingNoteHead, esrMessage: ErsMessage[] = []) => {
    const requirementCheck = { ...requirementFields }; 
    const allowZero = true
    //requirementCheck.diaryNumber = isPass(form?.diaryNumber);
    requirementCheck.tripNumber = isPass(form?.tripNumber);
    requirementCheck.firstCatchDate = isPass(form?.firstCatchDate);
    requirementCheck.lastCatchDate = isPass(form?.lastCatchDate);
    requirementCheck.catchYear = isPass(form?.catchYear);
    requirementCheck.crewSize = isPass(form?.crewSize);
    requirementCheck.norwegianCrewSize = isPass(form?.norwegianCrewSize);
    requirementCheck.vesselOfficersNorwegian = isPass(form?.vesselOfficersNorwegian, allowZero);
    // requirementCheck.departureDate = form?.departureDate !== null && form?.departureDate !== "";
    // requirementCheck.arrivalDate = form?.arrivalDate !== null && form?.arrivalDate !== "";
    requirementCheck.quotaTypeCode = isPass(form?.quotaTypeCode);
    requirementCheck.quotaNationCode = isPass(form?.quotaNationCode);
    requirementCheck.landingNationCode = isPass(form?.landingNationCode);
    requirementCheck.partialLandingId = isPass(form?.partialLandingId, allowZero);
    requirementCheck.vesselCaptainsName = isPass(form?.vesselCaptainsName);
    // requirementCheck.productionFacilityId = form?.productionFacilityId !== null && form?.productionFacilityId !== "";
    requirementCheck.fishingGearId = isPass(form?.fishingGearId);
    requirementCheck.catchField = isPass(form?.catchField);
    if(esrMessage.length > 0 && !isPass(form?.recordNumberErs)) {
      requirementCheck.recordNumberErs =  false;
    }else {
      requirementCheck.recordNumberErs = true
    }
    return requirementCheck;
  };
  
  
 export  const areAllRequirementsMet = (requirementCheck: typeof requirementFields) => {
    return Object.values(requirementCheck).every((value) => value === true);
  };

export const stepTwoRequirementCheck = (form: any[]) => {
    if (form.length === 0) {
        return false;
    }

    for (const line of form) {
        if (
            !line.productId ||
            line.productId === 0 ||
            line.packagingCode === "" ||
            line.packagingCode == null ||

            !line.grossLiveWeightKg ||
            line.grossLiveWeightKg === 0 ||
            line.grossLiveWeightKg < 0 ||

            !line.netLiveWeightKg ||
            line.netLiveWeightKg === 0 ||
            line.netLiveWeightKg < 0 

        )
        {
            return false;
        }

        if (line.grossLiveWeightKg < line.netLiveWeightKg) {
            return false;
        }

        if (line.piecesMandatory === 1) {
            if (!line.numberOfPieces || line.numberOfPieces === 0) {
                return false;
            }
        }
    }

    return true;
}